import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void
    dataLayer: unknown[]
  }
}

// Tracker une page vue (appelé automatiquement dans usePageTracking)
function trackPageView(path: string, title?: string) {
  if (typeof window.gtag !== 'function') return
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
  })
}

// Hook à placer dans le Layout pour tracker toutes les pages
export function usePageTracking() {
  const location = useLocation()

  useEffect(() => {
    trackPageView(location.pathname + location.search)
  }, [location])
}

// Tracker un événement custom (contact, devis, etc.)
export function trackEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>
) {
  if (typeof window.gtag !== 'function') return
  window.gtag('event', eventName, params)
}

// Événements prédéfinis pour Cy Art Luthier
export const Analytics = {
  // Formulaire contact soumis
  contactFormSubmit: () =>
    trackEvent('contact_form_submit', { form_type: 'contact' }),

  // Formulaire devis soumis
  devisFormSubmit: () =>
    trackEvent('contact_form_submit', { form_type: 'devis' }),

  // Formulaire RDV soumis
  rdvFormSubmit: () =>
    trackEvent('contact_form_submit', { form_type: 'rdv' }),

  // Clic sur un instrument dans le portfolio
  instrumentClick: (name: string) =>
    trackEvent('select_item', { item_name: name, item_category: 'instrument' }),

  // Clic sur "Appeler"
  phoneClick: () =>
    trackEvent('click', { type: 'phone_call' }),

  // Clic Instagram
  instagramClick: () =>
    trackEvent('click', { type: 'instagram_link' }),
}
